module.exports = __webpack_public_path__ + "img/1-2.b16aef91.jpg";